import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {

  constructor() { }
  banner = [
    {
      img: "assets/img/banner/01.jpg",
      subtitle: "Certificado de la Asociación <br> Angus Mexicana.",
      title: "Carne Angus <br> Certificada México.",
      link: "#",
      btnText: "Conocer el Certificado"
    },
    {
      img: "assets/img/banner/02.jpg",
      subtitle: "“El origen es la genética, Genética Angus”",
      title: "Angus Breeders, El Criador",
      link: "/service-details/1",
      btnText: "Angus Breeders"
    },
    {
      img: "assets/img/banner/03.jpg",
      subtitle: "“Genética y fuerza productiva Juntas”",
      title: "Angus Feeders, el Engordador",
      link: "/service-details/2",
      btnText: "Angus Feeders"
    },
    {
      img: "assets/img/banner/04.jpg",
      subtitle: "“El paso final en la producción de la mejor carne <br/>Carne Angus Certificada México”",
      title: "Quality & Food Safety",
      link: "/service-details/3",
      btnText: "Quality & Food Safety"
    },
    {
      img: "assets/img/banner/05.jpg",
      subtitle: "“Su punto de acceso a la mejor carne de México”",
      title: "Punto de venta",
      link: "/service-details/4",
      btnText: "Punto de venta"
    }
  ];
  settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    arrows: true,
    fade: false,
    dots: true,
    swipe: true,
    adaptiveHeight: true,
    nextArrow: '<button class="slick-arrow next-arrow"><i class="fal fa-long-arrow-right"></i></button>',
    prevArrow: '<button class="slick-arrow prev-arrow"><i class="fal fa-long-arrow-left"></i></button>',
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }]
  };

  ngOnInit(): void {
  }

  goToEstandar() {
    window.scroll({ 
      top: 1700, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

  goToValidar() {
    window.location.href = "/team"
  }

}
